import { ArticleMeta, articleTag } from "./types";

const META: ArticleMeta = {
    slug: "rag",
    section: "briefing",
    header: "Machine Learning",
    title: "RAG - Need Some Context!",
    description: "Hybrid search, reranking, and evaluation loops that keep generated answers grounded.",
    tags: [
        articleTag("deepseek.svg"),
        articleTag("python.svg"),
        articleTag("tensorflow.svg"),
        articleTag("elasticsearch.svg"),
        articleTag("jupyter-svgrepo-com.svg"),
    ],
    url: "/articles/rag",
};

export default META;
